import Vue from 'vue'


const BREAKPOINTS_DEFAULTS = {
    thresholds: {
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1920
    },
    scrollbarWidth: 16
};


// Factory function for the breakpoint mixin.
export function breakpoint(){

    return Vue.extend({
        data() {
            return {
                clientHeight: getClientHeight(),
                clientWidth: getClientWidth(),
                resizeTimeout: undefined,

                ...BREAKPOINTS_DEFAULTS,
            }
        },

        computed: {

            breakpoint() {
                const xs = this.clientWidth < this.thresholds.sm;
                const sm = this.clientWidth < (this.thresholds.md - this.scrollbarWidth) && !(xs);
                const md = this.clientWidth < (this.thresholds.lg - this.scrollbarWidth) && !(xs || sm);
                const lg = this.clientWidth < (this.thresholds.xl - this.scrollbarWidth) && !(xs || sm ||md );
                const xl = this.clientWidth >= (this.thresholds.xl - this.scrollbarWidth);

                const xsOnly = xs;
                const smOnly = sm;
                const mdOnly = md;
                const lgOnly = lg;
                const xlOnly = xl;

                const smAndDown = (xs || sm) && !(md || lg || xl);
                const mdAndDown = (xs || sm || md) && !(lg || xl);
                const lgAndDown = (xs || sm || md || lg) && !xl;

                const smAndUp = !xs && (sm || md || lg || xl);
                const mdAndUp = !(xs || sm) && (md || lg || xl);
                const lgAndUp = !(xs || sm || md) && (lg || xl);

                return {
                    // Definite breakpoint.
                    xs,
                    sm,
                    md,
                    lg,
                    xl,

                    // Breakpoint ranges.
                    xsOnly,
                    smOnly,
                    mdOnly,
                    lgOnly,
                    xlOnly,

                    smAndDown,
                    mdAndDown,
                    lgAndDown,
                    smAndUp,
                    mdAndUp,
                    lgAndUp,

                    // For custom breakpoint logic.
                    width: this.clientWidth,
                    height: this.clientHeight,
                    thresholds: this.thresholds,
                    scrollbarWidth: this.scrollbarWidth
                }
            }
        },

        // Aggancio evento su resize della finestra
        created() {
            if (typeof window === 'undefined') return;
            window.addEventListener('resize', this.onResize, {passive: true})
        },

        // Rimuovo aggancio evento su resize della finestra
        beforeDestroy() {
            if (typeof window === 'undefined') return;
            window.removeEventListener('resize', this.onResize)
        },

        methods: {

            // Gestione ridimensionamento della finestra
            onResize() {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = window.setTimeout(this.setDimensions, 200)
            },

            // Impostazioni dimensioni
            setDimensions() {
                this.clientHeight = getClientHeight();
                this.clientWidth = getClientWidth();
            }
        }
    })
}

function getClientWidth() {
    if (typeof document === 'undefined') return 0;
    return Math.max(document.documentElement ? document.documentElement.clientWidth : 0, window.innerWidth || 0);
}

function getClientHeight() {
    if (typeof document === 'undefined') return 0;
    return Math.max(document.documentElement ? document.documentElement.clientHeight : 0, window.innerHeight || 0);
}